export default __webpack_public_path__ + "static/media/garbage.0c006d91.svg";